import { render, staticRenderFns } from "./TableBarberLightening.vue?vue&type=template&id=5377f5cc&scoped=true"
import script from "./TableBarberLightening.vue?vue&type=script&lang=js"
export * from "./TableBarberLightening.vue?vue&type=script&lang=js"
import style0 from "./TableBarberLightening.vue?vue&type=style&index=0&id=5377f5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5377f5cc",
  null
  
)

export default component.exports